import { render, staticRenderFns } from "./ExpandableDataTable.vue?vue&type=template&id=102163ef&scoped=true&"
import script from "./ExpandableDataTable.vue?vue&type=script&lang=js&"
export * from "./ExpandableDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableDataTable.vue?vue&type=style&index=0&id=102163ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102163ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('102163ef')) {
      api.createRecord('102163ef', component.options)
    } else {
      api.reload('102163ef', component.options)
    }
    module.hot.accept("./ExpandableDataTable.vue?vue&type=template&id=102163ef&scoped=true&", function () {
      api.rerender('102163ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Overview/ExpandableDataTable/ExpandableDataTable.vue"
export default component.exports